/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import TableContainer from "@material-ui/core/TableContainer";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import tableStyle from "assets/jss/material-dashboard-react/components/tableStyle";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal";
import { restructureArrayFunc } from "utils/Utils";
import { headerLabel } from "assets/properties/properties";
import { loanApplicationStatus } from "assets/properties/properties";
import { useNavigate } from "react-router-dom";
import { formatAmount } from "utils/Utils";
const useStyles = makeStyles(tableStyle);

const DisbursalDisabled = ({
  setNext,
  setBack,
  loanApplicationId,
  customerProceedId,
  loanAccountNumber,
  showButton,
  closeModal,
  status,
  featureFlags,
  premiumDetails
}) => {
  const navigate = useNavigate();
  const classes = useStyles();
  const [tableColumns] = useState([
    "Disbursal Amount",
    "Adjustment",
    "Adjusted Account / Amount",
    "Net Amount Payable",
    "Cash",
    "Bank",
  ]);
  const [disbursalDetailsObj, setDisbursalDetailsObj] = useState([]);
  const { authToken } = useSelector((state) => state.login.authData);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [callInProgress, setCallInProgress] = useState(false);

  useEffect(() => {
    GetDisbursalDetails();
  }, []);

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  const GetDisbursalDetails = async () => {
    setCallInProgress(true);
    //DISBURSAL_GETDATA
    const res = await apiHandler({
      url: endpoint.DISBURSAL_GETDATA + loanApplicationId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error","please Provide correct disbursal Details data", true);
    } else {

      const restructureArray = restructureArrayFunc(res?.data);
      setDisbursalDetailsObj(restructureArray);
    }
  };
  const onBack = () => {
    setBack();
  };
  const onNext = () => {
    setNext();
  };
  const chargeTypeData =
    disbursalDetailsObj.filter((item) => item.chargeType) || [];
  const cashData =
    disbursalDetailsObj.filter((item) => item.paymentMode === "CASH") || [];
  const bankData =
    disbursalDetailsObj.filter((item) => item.paymentMode === "BANK") || [];
  const adjustedAccount =
    disbursalDetailsObj.filter((item) => item.adjustment === "YES") || [];
    const netPayableAmount = () =>{
      let payData = ""
   
      if((cashData?.length?.length || cashData?.[0]?.netPayable) && (bankData?.length || bankData?.[0]?.netPayable)){
        payData =cashData?.[0]?.netPayable + bankData?.[0]?.netPayable;
      }else if(cashData?.length || cashData?.[0]?.netPayable){
        payData =cashData?.[0]?.netPayable
      }else if(bankData?.length || bankData?.[0]?.netPayable){
        payData =bankData?.[0]?.netPayable
      }
      return payData;
    }
    const handleClose=()=>{
       if(status === loanApplicationStatus?.disburseToLms) {
            navigate("/loanservice/disbursLms", { state: { from: "" } });
          } else if(status === loanApplicationStatus?.completed) {
            navigate("/loanservice/completed", { state: { from: "" } });
          }else if(status === loanApplicationStatus?.rejected) {
            navigate("/loanservice/rejected", { state: { from: "" } });
          } else if(status === loanApplicationStatus?.discrepancy) {
            navigate("/loanservice/discrepancyApproval", { state: { from: "" } });
          } else {
            console.log("Handle other status or just close modal");
          }
    }
return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
       <SubHeader
             label={headerLabel?.disbursal}
            subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
             onlyLabel/>
         
        </Grid>
      </Grid>
      <GridContainer>
        <GridItem xs={12} sm={12} md={2} lg={2} style={{ textAlign: "start" }}>
          <CustomInput
            labelText="Loan Account Number"
            formControlProps={{
              fullWidth: true,
              style: { marginTop: 0 },
            }}
            inputProps={{
              name: "loan Account Number",
              disabled: true,
              value: loanAccountNumber,
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={2} lg={2} style={{ textAlign: "start" }}>
          <CustomInput
            labelText="Customer Id"
            formControlProps={{
              fullWidth: true,
              style: { marginTop: 0 },
            }}
            inputProps={{
              name: "customer Id",
              disabled: true,
              value: customerProceedId,
            }}
          />
        </GridItem>
        <GridItem xs={10} sm={10} md={6} lg={6}></GridItem>
          <GridItem
            xs={12}
            sm={12}
            md={2}
            lg={2}
            style={{ textAlign: "start" }}
          >
          <CustomInput
            labelText="Disbursal Date"
            formControlProps={{
              fullWidth: true,
              style: { marginTop: 0 },
            }}
            inputProps={{
              name: "customer Id",
              disabled: true,
              value: disbursalDetailsObj?.[0]?.disbursalDate,
            }}
          />
        </GridItem>

        <GridItem xs={10} sm={10} md={4} lg={4}></GridItem>
      </GridContainer>
      <TableContainer className={classes.tableContianer}>
        <Table
          stickyHeader
          style={{
            minWidth: window.innerWidth < 600 ? "250%" : "100%",
          }}
        >
          <TableHead>
            <TableRow className={classes.tableHeadRowDisbursal}>
              {tableColumns.map((item, i) => (
                <TableCell
                  key={i}
                  padding="checkbox"
                  className={classes.disbursalPostPledge}
                >
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow className={classes.tableBodyRowDisbursal}>
              <TableCell className={classes.disbursalPostPledges}>
                {
                  <CustomInput
                     id="disbursalAmount"
                    formControlProps={{
                      fullWidth: true,
                      style: { marginTop: 0 },
                    }}
                    inputProps={{
                      name: "disbursalAmount",
                      disabled: true,
                      value: formatAmount(disbursalDetailsObj?.[0]?.disbursalAmount),
                    }}
                  />
                }
              </TableCell>

              <div>
                {chargeTypeData?.length > 0 ? chargeTypeData?.map(
                  (item, index) =>
                    item?.adjustment && (
                      <div key={index} style={{ display: "flex" }}>
                        <TableCell style={{ width: "50%" }} className={classes.disbursalPostPledges}>
                          <CustomInput
                            id="adjustment"
                            key={index}
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              name: "adjustment",
                              disabled: true,
                              value: item?.adjustment,
                            }}
                          />
                        </TableCell>
                        <TableCell style={{ width: "50%" }} className={classes.disbursalPostPledges}>
                          <CustomInput
                            id="adjustedAmount"
                            key={index}
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              name: "adjustedAmount",
                              disabled: true,
                              value: item?.adjustedAmount,
                            }}
                          />
                        </TableCell>
                      </div>
                    )
                ) : (
                    <div  style={{ display: "flex" }}>
                        <TableCell style={{ width: "50%" }} className={classes.disbursalPostPledges}>
                          <CustomInput
                            id="adjustment"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              name: "adjustment",
                              disabled: true,
                              value: "",
                            }}
                          />
                        </TableCell>
                        <TableCell style={{ width: "50%" }} className={classes.disbursalPostPledges}>
                          <CustomInput
                            id="adjustedAmount"
      
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              name: "adjustedAmount",
                              disabled: true,
                              value: "",
                            }}
                          />
                        </TableCell>
                      </div>
                )
                }
              </div>

              <TableCell className={classes.disbursalPostPledges}>
                {
                  <CustomInput
                    id="netPayable"
                    formControlProps={{
                      fullWidth: true,
                      style: { marginTop: 0 },
                    }}
                    inputProps={{
                      name: "netPayable",
                      value: netPayableAmount(),
                      disabled: true,
                    }}
                  />
                }
              </TableCell>
              <TableCell className={classes.disbursalPostPledges}>
                {
                  <CustomInput
                      id="cash"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      name: "cash",
                      type: "number",
                      disabled: true,
                      value: cashData?.[0]?.netPayable,
                    }}
                  />
                }
              </TableCell>
              <TableCell className={classes.disbursalPostPledges}>
                {
                  <CustomInput
                      id="bank"
                    formControlProps={{
                      fullWidth: true,
                      style: { marginTop: 0 },
                    }}
                    inputProps={{
                      name: "bank",
                      type: "number",
                      value: bankData?.[0]?.netPayable,
                      disabled: true,
                    }}
                  />
                }
              </TableCell>
            </TableRow>
            {Number(premiumDetails?.totalPremium) > 0 &&
              <TableRow className={classes.tableBodyRowDisbursal}>
                <TableCell
                  className={classes.disbursalPostPledges}
                  style={{ width: "16%" }}
                >
                </TableCell>
                <TableCell className={classes.disbursalPostPledges} style={{width:'15.5%'}}>
                  <CustomInput
                    id={`adjustment_insurance`}
                    formControlProps={{
                      fullWidth: true,
                      style: { marginTop: 0 },
                    }}
                    inputProps={{
                      name: "adjustment",
                      disabled: true,
                      value: "INSURANCE_PREMIUM",
                    }}
                  />
                </TableCell>
                <TableCell className={classes.disbursalPostPledges} >
                  <CustomInput
                    id={`charge_amount_insurance`}
                    formControlProps={{
                      fullWidth: true,
                      style: { marginTop: 0, maxWidth: "100px" },
                    }}
                    inputProps={{
                      name: "Charge Amount",
                      disabled: true,
                      value: Number(premiumDetails?.totalPremium),
                    }}
                  />
                </TableCell>
                <TableCell className={classes.disbursalPostPledges} />
              </TableRow>
            }
            {adjustedAccount?.length > 0 && adjustedAccount?.map((item, index) => (
                <TableRow className={classes.tableBodyRowDisbursal} key={index}>
                  <TableCell
                    className={classes.disbursalPostPledges}
                    style={{ width: "16%" }}
                  >
                    <CustomInput
                      id="adjustment"
                      formControlProps={{
                        fullWidth: true,
                        style: { marginTop: "12px" },
                      }}
                      inputProps={{
                        name: "Adjustment",
                        classes: { input: classes.inputStyle },
                        disabled: true,
                        value: "YES",
                      }}
                    />
                  </TableCell>
                  <TableCell className={classes.disbursalPostPledges} style={{width:'15.5%'}}>
                      <CustomInput
                        id="adjustedLoanAccountNumber"
                        formControlProps={{
                          fullWidth: true,
                          style: {
                            marginTop: 0,
                          },
                        }}
                        inputProps={{
                          name: "adjustedLoanAccountNumber",
                          disabled: true,
                          value: item?.adjustedLoanAccountNumber,
                        }}
                      />
                    
                  </TableCell>
              <TableCell className={classes.disbursalPostPledges} >
              <CustomInput
                        id="adjustedAmount"
                        formControlProps={{
                          fullWidth: true,
                          style: {
                            marginTop: 0,
                          },
                        }}
                        inputProps={{
                          name: "adjustedAmount",
                          disabled: true,
                          value: item?.adjustedAmount,
                        }}
                      />
                    </TableCell>
              <TableCell className={classes.disbursalPostPledges} />
            </TableRow>
                ))}
          </TableBody>
        </Table>
      </TableContainer>
      {cashData?.[0]?.cashReceiptLink &&
        <GridItem
          xs={12}
          sm={6}
          md={6}
          lg={6}
          style={{ textAlign: "start", marginTop: "20px" }}
        >
          <a 
            href={cashData?.[0]?.cashReceiptLink} 
            style={{
              marginTop: 6,
              fontWeight: 600,
              cursor: "pointer",
              fontSize: "16px",
            }} 
            target="_blank" 
            rel="noopener noreferrer"
          >
            View Cash Acknowledgement
          </a>
        </GridItem>
      }
      <GridItem
        xs={12}
        sm={showButton ? 6 : 12}
        md={showButton ? 6 : 12}
        lg={showButton ? 6 : 12}
        style={{
          textAlign: window.innerWidth < 360 ? "center" : "right",
          marginTop: "10px",
        }}
      >
        <Button
          key={"btnB"}
          size="small"
          className={classes.nextButton1}
          disabled={callInProgress}
          onClick={() => onBack()}
        >
          Back
        </Button>
        <Button
          key={"btnP"}
          size="small"
          className={classes.nextButton1}
          onClick={() =>status!=="DISBURSALTOLMS"?handleClose():onNext()}
          >
           {status!=="DISBURSALTOLMS"? "Close":"Next"}
        </Button>
      </GridItem>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </div>
  );
};

DisbursalDisabled.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  closeModal: PropTypes.func,
  loanApplicationId: PropTypes.number,
  editable: PropTypes.bool,
};

export default DisbursalDisabled;
